module.exports = __webpack_public_path__ + "static/media/norecord.7463acc1.png";